import React from 'react';
import { Layout, Spin, Icon } from 'antd';
import s from './style.less';

const { content } = Layout;

const Welcome = () => {
  const antIcon = <Icon type="loading" className={s.antIcon} spin />;
  return (
    <content className={s.waiting}>
      <Spin size="large" indicator={antIcon} className={s.spin} />
    </content>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/views/Welcome/Welcome.jsx